import { apiExecutePost,apiExecutePostWithProgress } from './api';
import { AxiosProgressEvent } from 'axios';
const emailServiceUrl = import.meta.env.VITE_MAIL_SERVICE_URL;

export const uploadFileRnd = async ({ files, orderId }: { files: File[]; orderId: string }) => {
  const formData = new FormData();
  formData.append('foldername', orderId);
  files.forEach((file) => {
    formData.append('files', file);
  });

  try {
    const response = await apiExecutePost(`${emailServiceUrl}/files/uploads`, formData);
    return response;
  } catch (error) {
    console.error('Error during upload file to rnd:', error);
    return null;
  }
};
export const uploadFileRndWithProgress = async (
  {
    files,
    orderId,
    onUploadProgress,
    signal,
  }: {
    files: File[];
    orderId: string;
    onUploadProgress?: (progressEvent: AxiosProgressEvent) => void;
    signal?: AbortSignal;
  }
) => {
  const formData = new FormData();
  formData.append('foldername', orderId);
  files.forEach((file) => {
    formData.append('files', file);
  });

  try {
    const response = await apiExecutePostWithProgress(
      `${emailServiceUrl}/files/uploads`,
      formData,
      window.location.origin,
      {
        onUploadProgress,
        signal,
      }
    );
    return response;
  } catch (error) {
    console.error('Error during upload file to rnd:', error);
    return {error};
  }
};



